import React from "react"
import { FormInputWrapper, Label, Select, HelpText, ValidationText } from "../../styles"
import PropTypes from "prop-types"
import { SELECT_PLACEHOLDER_VALUE } from "../../../constants"

function SelectInput({
  label,
  id,
  options = [],
  onChange,
  value,
  helpText,
  validationText,
  ...otherProps
}) {
  const handleOnChangeValue = (e) => {
    const selectedValue = options.find(
      (option) => String(option.value) === String(e.target.value)
    )
    if (!selectedValue) return
    onChange(selectedValue.value, id)
  }
  return (
    <FormInputWrapper>
    {label && <Label htmlFor={id} dangerouslySetInnerHTML={{ __html: label }}></Label>}
      <Select
        id={id}
        value={value}
        {...otherProps}
        onChange={handleOnChangeValue}
      >
        <option value="" disabled={true}>
          {SELECT_PLACEHOLDER_VALUE}
        </option>
        {options.map((item) => (
          <option
            key={`${id}-${item.value}`}
            value={item.value}
            disabled={item.disabled}
          >
            {item.label || item.value}
          </option>
        ))}
      </Select>
    {validationText && <ValidationText htmlFor={id}>{validationText}</ValidationText>}
    {helpText && <HelpText htmlFor={id}>{helpText}</HelpText>}

    </FormInputWrapper>
  )
}

/** Accepts the below, as well as any of the usual select input props */
SelectInput.propTypes = {
  /** Called on change of value, with new value and id */
  onChange: PropTypes.func,
  /** The label for the input */
  label: PropTypes.string,
  /** A unique id for the input, e.g a field name */
  id: PropTypes.string,
  /** Array of options to display */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /** The value of the option */
      value: PropTypes.any,
      /** The display label for the option. Uses value if not set */
      label: PropTypes.string,
      /** Whether the option is disabled */
      disabled: PropTypes.bool,
    })
  ),
  /** The value of the input */
  value: PropTypes.any,
  /** The helptext below the input */
  helpText: PropTypes.string,
  /** The validation text  below the input */
  helpText: PropTypes.string,
}

export default SelectInput
